import { AdTemplate, BRAND, createBackground, imageSlot, shape, text, unit } from './shared';

/** Układy dołożone później: listy, porównania, zrzuty ekranu, ogłoszenia, liczby. */
export const EXTRA_TEMPLATES: AdTemplate[] = [

  {
    id: 'checklist',
    label: 'Trzy powody',
    description: 'Numerowana lista argumentów pod nagłówkiem',
    preview: { from: BRAND.deep, to: BRAND.teal, accent: BRAND.gold },
    build: (width, height) => {
      const u = unit(width, height);
      const margin = width * 0.08;
      const contentWidth = width - margin * 2;
      const rowHeight = height * 0.11;
      const rows = [
        'Recepcja odbiera mniej telefonów',
        'Zamówienia nie giną na kartkach',
        'Gość płaci kartą od razu',
      ];

      return {
        background: { ...createBackground(), kind: 'solid', color: BRAND.deep },
        elements: [
          text('Nagłówek', {
            text: 'Trzy powody, dla których hotele wdrażają Hotelspot',
            x: margin,
            y: height * 0.14,
            width: contentWidth,
            fontSize: u * 0.055,
            fontWeight: 900,
            align: 'left',
            lineHeight: 1.15,
          }),
          ...rows.flatMap((row, index) => [
            text(`Numer ${index + 1}`, {
              text: String(index + 1),
              x: margin,
              y: height * 0.42 + rowHeight * index,
              width: u * 0.09,
              fontSize: u * 0.06,
              fontWeight: 900,
              align: 'left',
              color: BRAND.gold,
            }),
            text(`Powód ${index + 1}`, {
              text: row,
              x: margin + u * 0.11,
              y: height * 0.43 + rowHeight * index,
              width: contentWidth - u * 0.11,
              fontSize: u * 0.032,
              fontWeight: 500,
              align: 'left',
              lineHeight: 1.35,
              color: '#dbeae6',
            }),
          ]),
          text('Stopka', {
            text: 'hotelspot.pl',
            x: margin,
            y: height * 0.86,
            width: contentWidth,
            fontSize: u * 0.026,
            fontWeight: 700,
            align: 'left',
            color: BRAND.gold,
          }),
        ],
      };
    },
  },

  {
    id: 'comparison',
    label: 'Przed i po',
    description: 'Dwie kolumny z kontrastem sytuacji',
    preview: { from: '#3f3f46', to: BRAND.mint, accent: BRAND.gold },
    build: (width, height) => {
      const u = unit(width, height);
      const gap = width * 0.04;
      const columnWidth = (width - gap * 3) / 2;
      const top = height * 0.3;
      const columnHeight = height * 0.48;
      const inset = u * 0.04;

      return {
        background: { ...createBackground(), kind: 'solid', color: BRAND.deep },
        elements: [
          text('Nagłówek', {
            text: 'Recepcja przed i po wdrożeniu',
            x: gap,
            y: height * 0.13,
            width: width - gap * 2,
            fontSize: u * 0.055,
            fontWeight: 900,
          }),
          shape('Kolumna przed', {
            x: gap,
            y: top,
            width: columnWidth,
            height: columnHeight,
            fill: '#27272a',
            radius: u * 0.03,
          }),
          shape('Kolumna po', {
            x: gap * 2 + columnWidth,
            y: top,
            width: columnWidth,
            height: columnHeight,
            fill: BRAND.mint,
            radius: u * 0.03,
          }),
          text('Tytuł przed', {
            text: 'Przed',
            x: gap + inset,
            y: top + inset,
            width: columnWidth - inset * 2,
            fontSize: u * 0.032,
            fontWeight: 800,
            align: 'left',
            uppercase: true,
            color: '#a1a1aa',
          }),
          text('Opis przed', {
            text: 'Telefon do recepcji, kartka z zamówieniem, płatność przy wymeldowaniu.',
            x: gap + inset,
            y: top + inset + u * 0.07,
            width: columnWidth - inset * 2,
            fontSize: u * 0.026,
            fontWeight: 400,
            align: 'left',
            lineHeight: 1.4,
            color: '#e4e4e7',
          }),
          text('Tytuł po', {
            text: 'Po',
            x: gap * 2 + columnWidth + inset,
            y: top + inset,
            width: columnWidth - inset * 2,
            fontSize: u * 0.032,
            fontWeight: 800,
            align: 'left',
            uppercase: true,
            color: BRAND.deep,
          }),
          text('Opis po', {
            text: 'Gość zamawia z telefonu, zespół widzi zgłoszenie od razu, płatność online.',
            x: gap * 2 + columnWidth + inset,
            y: top + inset + u * 0.07,
            width: columnWidth - inset * 2,
            fontSize: u * 0.026,
            fontWeight: 400,
            align: 'left',
            lineHeight: 1.4,
            color: BRAND.deep,
          }),
        ],
      };
    },
  },

  {
    id: 'screens',
    label: 'Dwa zrzuty ekranu',
    description: 'Miejsce na widoki aplikacji obok opisu',
    preview: { from: BRAND.light, to: '#e4e4e7', accent: BRAND.teal },
    build: (width, height) => {
      const u = unit(width, height);
      const margin = width * 0.07;
      const contentWidth = width - margin * 2;
      const screenWidth = contentWidth * 0.44;
      const screenTop = height * 0.42;
      const screenHeight = height * 0.44;

      return {
        background: { ...createBackground(), kind: 'solid', color: BRAND.light },
        elements: [
          text('Nadtytuł', {
            text: 'Panel i aplikacja gościa',
            x: margin,
            y: height * 0.13,
            width: contentWidth,
            fontSize: u * 0.028,
            fontWeight: 700,
            uppercase: true,
            letterSpacing: u * 0.008,
            align: 'left',
            color: BRAND.gold,
          }),
          text('Nagłówek', {
            text: 'Wszystko w jednym miejscu',
            x: margin,
            y: height * 0.2,
            width: contentWidth,
            fontSize: u * 0.06,
            fontWeight: 900,
            align: 'left',
            color: BRAND.deep,
            lineHeight: 1.12,
          }),
          imageSlot('Zrzut ekranu 1', {
            x: margin,
            y: screenTop,
            width: screenWidth,
            height: screenHeight,
            radius: u * 0.03,
          }),
          imageSlot('Zrzut ekranu 2', {
            x: margin + contentWidth - screenWidth,
            y: screenTop,
            width: screenWidth,
            height: screenHeight,
            radius: u * 0.03,
          }),
        ],
      };
    },
  },

  {
    id: 'announcement',
    label: 'Ogłoszenie',
    description: 'Plakietka, mocny komunikat i jedno zdanie',
    preview: { from: BRAND.gold, to: '#e2b07a', accent: BRAND.deep },
    build: (width, height) => {
      const u = unit(width, height);
      const margin = width * 0.1;
      const contentWidth = width - margin * 2;

      return {
        background: {
          ...createBackground(),
          kind: 'gradient',
          gradientFrom: BRAND.gold,
          gradientTo: '#e2b07a',
          gradientAngle: 140,
        },
        elements: [
          text('Plakietka', {
            text: 'Nowa integracja',
            x: margin,
            y: height * 0.2,
            width: contentWidth * 0.55,
            fontSize: u * 0.026,
            fontWeight: 800,
            uppercase: true,
            letterSpacing: u * 0.005,
            color: BRAND.gold,
            background: BRAND.deep,
            backgroundRadius: 999,
            padding: u * 0.022,
          }),
          text('Komunikat', {
            text: 'Hotelspot łączy się z Twoim PMS',
            x: margin,
            y: height * 0.36,
            width: contentWidth,
            fontSize: u * 0.075,
            fontWeight: 900,
            align: 'left',
            lineHeight: 1.1,
            color: BRAND.deep,
          }),
          text('Opis', {
            text: 'Dane pobytu i rachunek gościa bez przepisywania z systemu do systemu.',
            x: margin,
            y: height * 0.66,
            width: contentWidth,
            fontSize: u * 0.03,
            fontWeight: 500,
            align: 'left',
            lineHeight: 1.45,
            color: '#3d2a14',
          }),
        ],
      };
    },
  },

  {
    id: 'stats',
    label: 'Trzy liczby',
    description: 'Zestaw wyników wdrożenia',
    preview: { from: BRAND.deep, to: BRAND.mint, accent: '#ffffff' },
    build: (width, height) => {
      const u = unit(width, height);
      const margin = width * 0.08;
      const contentWidth = width - margin * 2;
      const rowHeight = height * 0.16;
      const stats = [
        { value: '+31%', label: 'zamówień room service' },
        { value: '2x', label: 'szybsza obsługa zgłoszeń' },
        { value: '48h', label: 'wdrożenie w obiekcie' },
      ];

      return {
        background: {
          ...createBackground(),
          kind: 'gradient',
          gradientFrom: BRAND.deep,
          gradientTo: BRAND.mint,
          gradientAngle: 150,
        },
        elements: [
          text('Nagłówek', {
            text: 'Co zmienia się po wdrożeniu',
            x: margin,
            y: height * 0.14,
            width: contentWidth,
            fontSize: u * 0.05,
            fontWeight: 800,
            align: 'left',
          }),
          ...stats.flatMap((stat, index) => [
            text(`Liczba ${index + 1}`, {
              text: stat.value,
              x: margin,
              y: height * 0.36 + rowHeight * index,
              width: contentWidth * 0.35,
              fontSize: u * 0.07,
              fontFamily: 'Anton',
              fontWeight: 400,
              align: 'left',
              lineHeight: 1,
            }),
            text(`Podpis ${index + 1}`, {
              text: stat.label,
              x: margin + contentWidth * 0.38,
              y: height * 0.38 + rowHeight * index,
              width: contentWidth * 0.62,
              fontSize: u * 0.028,
              fontWeight: 500,
              align: 'left',
              lineHeight: 1.35,
              color: '#d7f0e7',
            }),
          ]),
        ],
      };
    },
  },

  {
    id: 'blank',
    label: 'Pusta plansza',
    description: 'Startujesz od czystego tła',
    preview: { from: '#f4f4f5', to: '#e4e4e7', accent: '#a1a1aa' },
    build: () => ({
      background: { ...createBackground(), kind: 'solid', color: '#ffffff' },
      elements: [],
    }),
  },
];
